@file:OptIn(InternalResourceApi::class)

package mobile_wallet.cmp_shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.cmp_shared.generated.resources/"

public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 28),
      ))
    }

public val Res.string.default: StringResource by lazy {
      StringResource("string:default", "default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39, 27),
      ))
    }

public val Res.string.error_message: StringResource by lazy {
      StringResource("string:error_message", "error_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67, 37),
      ))
    }

public val Res.string.faq: StringResource by lazy {
      StringResource("string:faq", "faq", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105, 15),
      ))
    }

public val Res.string.finance: StringResource by lazy {
      StringResource("string:finance", "finance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121, 27),
      ))
    }

public val Res.string.home: StringResource by lazy {
      StringResource("string:home", "home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149, 20),
      ))
    }

public val Res.string.interbank_server: StringResource by lazy {
      StringResource("string:interbank_server", "interbank_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 170, 48),
      ))
    }

public val Res.string.main_server: StringResource by lazy {
      StringResource("string:main_server", "main_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219, 35),
      ))
    }

public val Res.string.no_interbank_servers: StringResource by lazy {
      StringResource("string:no_interbank_servers", "no_interbank_servers", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255, 68),
      ))
    }

public val Res.string.not_connected: StringResource by lazy {
      StringResource("string:not_connected", "not_connected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324, 81),
      ))
    }

public val Res.string.payments: StringResource by lazy {
      StringResource("string:payments", "payments", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 406, 28),
      ))
    }

public val Res.string.profile: StringResource by lazy {
      StringResource("string:profile", "profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 435, 27),
      ))
    }

public val Res.string.select_instance: StringResource by lazy {
      StringResource("string:select_instance", "select_instance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 463, 43),
      ))
    }

public val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 507, 28),
      ))
    }

public val Res.string.tenant_value: StringResource by lazy {
      StringResource("string:tenant_value", "tenant_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 536, 36),
      ))
    }

public val Res.string.update: StringResource by lazy {
      StringResource("string:update", "update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 573, 22),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("default", Res.string.default)
  map.put("error_message", Res.string.error_message)
  map.put("faq", Res.string.faq)
  map.put("finance", Res.string.finance)
  map.put("home", Res.string.home)
  map.put("interbank_server", Res.string.interbank_server)
  map.put("main_server", Res.string.main_server)
  map.put("no_interbank_servers", Res.string.no_interbank_servers)
  map.put("not_connected", Res.string.not_connected)
  map.put("payments", Res.string.payments)
  map.put("profile", Res.string.profile)
  map.put("select_instance", Res.string.select_instance)
  map.put("settings", Res.string.settings)
  map.put("tenant_value", Res.string.tenant_value)
  map.put("update", Res.string.update)
}
